import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/en";
import VeeValidate from "vee-validate";
import Vue from "vue";
import VueNotify from "vue-notifyjs";
import App from "./App.vue";
import "./pollyfills";
import router from "src/routes/router";

// Plugins
import SideBar from "./components/UIComponents/SidebarPlugin";
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";
import { Table, TableColumn, Select, Option, Loading } from "element-ui";

// library imports
import "./assets/sass/demo.scss";
import "./assets/sass/paper-dashboard.scss";
import store from "./store";

import "./registerServiceWorker";
import sidebarLinks from "./sidebarLinks";


Vue.use(Loading.directive);
// plugin setup
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(GlobalDirectives);
Vue.use(GlobalComponents);
Vue.use(VueNotify);
Vue.use(SideBar, { sidebarLinks: sidebarLinks });
Vue.use(require("vue-moment"));

Vue.use(VeeValidate);
locale.use(lang);

// configure router

export default new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store
});
